export default defineNuxtRouteMiddleware(async (to) => {
  devConsole.info("🛠️ Facility middleware", to.fullPath);

  const { loadCurrentFacility, clearCurrentFacility } = useFacilityApi();
  const facilityWizardGuard = useFacilityWizardGuard();
  const facilityImportGuard = useFacilityImportGuard();
  const facilityIdParam = to.params.facilityId?.toString();
  const facilityId = Number(facilityIdParam);

  if (facilityIdParam && facilityId) {
    const facility = await loadCurrentFacility(facilityId);
    if (!facility) {
      devConsole.error(
        `🚦 middleware rule triggered: Failed to load facility with ID ${facilityId}`,
      );
      return navigateTo(facilityWizardGuard.homeRoute.value);
    }
  } else {
    await clearCurrentFacility();
  }

  const canUseFacilityWizardFeature =
    await facilityWizardGuard.guardFeatureRoute(to);
  if (!canUseFacilityWizardFeature.ok) {
    return canUseFacilityWizardFeature.result;
  }

  const canUseFacilityImportFeature =
    await facilityImportGuard.guardFeatureRoute(to);
  if (!canUseFacilityImportFeature.ok) {
    return canUseFacilityImportFeature.result;
  }
});
